// =============================================================================
// src/data/manaus-zones.ts — Mapeamento das 6 zonas eleitorais de Manaus.
//
// Proveniencia: assets/unified-app.js DATA.zonaKeyMap / DATA.zonaDisplayName /
//   DATA.zonaPopData / DATA.groups / DATA.zoneGroupData (linhas 80-162).
//   Portado verbatim; o zonaKeyMap traduz o rotulo bruto do GeoJSON
//   (feature.properties.ZONAS, ex.: 'ZONA NORTE') para a ZonaKey canonica.
// =============================================================================

import type {
  ZonaKeyMap,
  ZonaDisplayNameMap,
  ZonaPopDataMap,
  GroupsMap,
  ZoneGroupDataMap,
} from '../app/types';

/** Rotulo bruto do GeoJSON -> ZonaKey canonica (DATA.zonaKeyMap). */
export const MANAUS_ZONA_KEY_MAP: ZonaKeyMap = {
  'ZONA NORTE': 'norte',
  'ZONA SUL': 'sul',
  'ZONA LESTE': 'leste',
  'ZONA OESTE': 'oeste',
  'ZONA CENTRO-OESTE': 'centro-oeste',
  'ZONA CENTRO-SUL': 'centro-sul',
};

/** ZonaKey -> nome de exibicao "Centro-Oeste" (DATA.zonaDisplayName). */
export const MANAUS_ZONA_DISPLAY_NAME: ZonaDisplayNameMap = {
  norte: 'Norte',
  sul: 'Sul',
  leste: 'Leste',
  oeste: 'Oeste',
  'centro-oeste': 'Centro-Oeste',
  'centro-sul': 'Centro-Sul',
};

/** Populacao formatada por zona (DATA.zonaPopData). */
export const MANAUS_ZONA_POP_DATA: ZonaPopDataMap = {
  norte: { hab: '692.000', eleitores: '412.000' },
  sul: { hab: '480.000', eleitores: '288.000' },
  leste: { hab: '580.000', eleitores: '348.000' },
  oeste: { hab: '345.000', eleitores: '207.000' },
  'centro-oeste': { hab: '310.000', eleitores: '186.000' },
  'centro-sul': { hab: '370.000', eleitores: '222.000' },
};

/** Definicao dos 3 grupos politicos do Comparador (DATA.groups). */
export const MANAUS_GROUPS: GroupsMap = {
  A: { name: 'Base Lula AM', color: '#534AB7' },
  B: { name: 'Direita PL+UB', color: '#BA7517' },
  C: { name: 'Centrão', color: '#1D9E75' },
};

/** Share percentual dos 3 grupos por zona (DATA.zoneGroupData). */
export const MANAUS_ZONE_GROUP_DATA: ZoneGroupDataMap = {
  norte: { A: 22, B: 28, C: 50 },
  leste: { A: 20, B: 30, C: 50 },
  'centro-oeste': { A: 25, B: 29, C: 46 },
  'centro-sul': { A: 15, B: 58, C: 27 },
  oeste: { A: 52, B: 26, C: 22 },
  sul: { A: 20, B: 42, C: 38 },
};
